import React from 'react';

import UserFilter from 'components/Filters/UserFilter';

import { Filter, FilterActions } from '@gogame/filters';

import { CREATION_PERIOD_PRESETS } from './presets';

import {
  FILTER_CREATIVE_CREATED_BY,
  FILTER_CREATIVE_TYPES,
  FILTER_CREATIVE_LANGUAGES,
  FILTER_CREATIVE_LENGTH,
  FILTER_CREATIVE_MEDIA_TYPES,
  FILTER_CREATIVE_ORIENTATIONS,
  FILTER_CREATIVE_REQUESTED_BY,
  FILTER_CREATIVE_RESOLUTIONS,
  FILTER_CREATIVE_SIZES,
  FILTER_CREATIVE_AUTHORS,
  FILTER_CREATIVE_PRODUCTION_TYPES,
  FILTER_CREATIVE_ENHANCERS,
  FILTER_CREATIVE_OS,
  FILTER_CREATIVE_COLORS,
  FILTER_CREATIVE_INCLUDED_TAGS,
  FILTER_CREATIVE_EXCLUDED_TAGS,
  FILTER_CREATIVE_STATUSES,
  FILTER_CREATIVE_CREATION_PERIOD,
  FILTER_CREATIVE_CONCEPT_CREATION_PERIOD,
  FILTER_CREATIVE_END_CARD,
  FILTER_CREATIVE_TESTED,
  FILTER_IS_AI_CREATED,
} from './constants';
import {
  loadCreativeCreatedBy,
  loadCreativeTypes,
  loadCreativeLanguages,
  loadCreativeMediaTypes,
  loadCreativeOrientations,
  loadCreativeRequestedBy,
  loadCreativeResolutions,
  loadCreativeSizes,
  loadCreativeAuthors,
  loadCreativeProductionTypes,
  loadCreativeEnhancers,
  loadCreativeOS,
  loadCreativeColors,
  loadCreativeIncludedTags,
  loadCreativeExcludedTags,
  loadCreativeStatuses,
  loadEndCards,
  loadTested,
  loadCreativeAiCreatedTypes,
} from './sources/filters';

import { isGoGameEnv } from 'App/constants';

const DEPENDENCIES = {
  [FILTER_CREATIVE_CREATED_BY]: [],
  [FILTER_CREATIVE_TYPES]: [FILTER_CREATIVE_MEDIA_TYPES],
  [FILTER_CREATIVE_LANGUAGES]: [],
  [FILTER_CREATIVE_LENGTH]: [
    FILTER_CREATIVE_MEDIA_TYPES,
    FILTER_CREATIVE_TYPES,
  ],
  [FILTER_CREATIVE_MEDIA_TYPES]: [FILTER_CREATIVE_TYPES],
  [FILTER_CREATIVE_ORIENTATIONS]: [],
  [FILTER_CREATIVE_REQUESTED_BY]: [],
  [FILTER_CREATIVE_RESOLUTIONS]: [],
  [FILTER_CREATIVE_AUTHORS]: [],
  [FILTER_CREATIVE_ENHANCERS]: [],
  [FILTER_CREATIVE_OS]: [],
  [FILTER_CREATIVE_COLORS]: [],
  [FILTER_CREATIVE_INCLUDED_TAGS]: [],
  [FILTER_CREATIVE_EXCLUDED_TAGS]: [],
  [FILTER_CREATIVE_STATUSES]: [],
  [FILTER_CREATIVE_END_CARD]: [],
};

const CreatedByFilter = (props) => (
  <UserFilter
    title={'Created by'}
    placeholder={'All'}
    name={FILTER_CREATIVE_CREATED_BY}
    source={loadCreativeCreatedBy}
    depends={DEPENDENCIES[FILTER_CREATIVE_CREATED_BY]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const CreativeTypesFilter = (props) => (
  <Filter.MultiSelect
    title={'Creative types'}
    placeholder={'All'}
    name={FILTER_CREATIVE_TYPES}
    source={loadCreativeTypes}
    depends={DEPENDENCIES[FILTER_CREATIVE_TYPES]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const LanguagesFilter = (props) => (
  <Filter.MultiSelect
    title={'Languages'}
    placeholder={'All'}
    name={FILTER_CREATIVE_LANGUAGES}
    source={loadCreativeLanguages}
    depends={DEPENDENCIES[FILTER_CREATIVE_LANGUAGES]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);
const LengthsFilter = (props) => {
  return (
    <Filter.NumberRangeInput
      title={'Lengths (sec)'}
      name={FILTER_CREATIVE_LENGTH}
      {...props}
    />
  );
};

const MediaTypesFilter = (props) => (
  <Filter.MultiSelect
    title={'Media Types'}
    placeholder={'All'}
    name={FILTER_CREATIVE_MEDIA_TYPES}
    source={loadCreativeMediaTypes}
    depends={DEPENDENCIES[FILTER_CREATIVE_MEDIA_TYPES]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const OrientationsFilter = (props) => (
  <Filter.MultiSelect
    title={'Orientations'}
    placeholder={'All'}
    name={FILTER_CREATIVE_ORIENTATIONS}
    source={loadCreativeOrientations}
    depends={DEPENDENCIES[FILTER_CREATIVE_ORIENTATIONS]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const RequestedByFilter = (props) => (
  <UserFilter
    title={'Requested by'}
    placeholder={'All'}
    name={FILTER_CREATIVE_REQUESTED_BY}
    source={loadCreativeRequestedBy}
    depends={DEPENDENCIES[FILTER_CREATIVE_REQUESTED_BY]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const ResolutionsFilter = (props) => (
  <Filter.MultiSelect
    title={'Resolutions'}
    placeholder={'All'}
    name={FILTER_CREATIVE_RESOLUTIONS}
    source={loadCreativeResolutions}
    depends={DEPENDENCIES[FILTER_CREATIVE_RESOLUTIONS]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const SizesFilter = (props) => (
  <Filter.MultiSelect
    title={'Sizes'}
    placeholder={'All'}
    name={FILTER_CREATIVE_SIZES}
    source={loadCreativeSizes}
    depends={DEPENDENCIES[FILTER_CREATIVE_SIZES]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const AuthorsFilter = (props) => (
  <Filter.MultiSelect
    title={'Authors'}
    placeholder={'All'}
    name={FILTER_CREATIVE_AUTHORS}
    source={loadCreativeAuthors}
    depends={DEPENDENCIES[FILTER_CREATIVE_AUTHORS]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const ProductionTypesFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Production types'}
      name={FILTER_CREATIVE_PRODUCTION_TYPES}
      source={loadCreativeProductionTypes}
      placeholder={'All'}
      withAll={false}
      {...props}
    />
  );
};

const EnhancersFilter = (props) => (
  <Filter.MultiSelect
    title={'Enhancers'}
    placeholder={'All'}
    name={FILTER_CREATIVE_ENHANCERS}
    source={loadCreativeEnhancers}
    depends={DEPENDENCIES[FILTER_CREATIVE_ENHANCERS]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const OSFilter = (props) => (
  <Filter.MultiSelect
    title={'OS'}
    placeholder={'All'}
    name={FILTER_CREATIVE_OS}
    source={loadCreativeOS}
    depends={DEPENDENCIES[FILTER_CREATIVE_OS]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);
const ColorsFilter = (props) => (
  <Filter.MultiSelect
    title={'Colors'}
    placeholder={'All'}
    name={FILTER_CREATIVE_COLORS}
    source={loadCreativeColors}
    depends={DEPENDENCIES[FILTER_CREATIVE_COLORS]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const IncludedTagsFilter = (props) => (
  <Filter.MultiSelect
    title={'Included Internal Tags'}
    placeholder={'All'}
    name={FILTER_CREATIVE_INCLUDED_TAGS}
    source={loadCreativeIncludedTags}
    depends={DEPENDENCIES[FILTER_CREATIVE_INCLUDED_TAGS]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const ExcludedTagsFilter = (props) => (
  <Filter.MultiSelect
    title={'Excluded Internal Tags'}
    placeholder={'All'}
    name={FILTER_CREATIVE_EXCLUDED_TAGS}
    source={loadCreativeExcludedTags}
    depends={DEPENDENCIES[FILTER_CREATIVE_EXCLUDED_TAGS]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const EndCardFilter = (props) => (
  <Filter.MultiSelect
    title={'Included end card'}
    placeholder={'All'}
    name={FILTER_CREATIVE_END_CARD}
    source={loadEndCards}
    depends={DEPENDENCIES[FILTER_CREATIVE_END_CARD]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const StatusesFilter = (props) => (
  <Filter.MultiSelect
    title={'Statuses'}
    placeholder={'All'}
    name={FILTER_CREATIVE_STATUSES}
    source={loadCreativeStatuses}
    depends={DEPENDENCIES[FILTER_CREATIVE_STATUSES]}
    compareActions={[<FilterActions.Equalize />]}
    {...props}
  />
);

const CreationPeriodFilter = (props) => {
  return (
    <Filter.DateRangePicker
      title={'Creative added'}
      placeholder={'Select period'}
      name={FILTER_CREATIVE_CREATION_PERIOD}
      maxDate={new Date()}
      {...props}
      presets={CREATION_PERIOD_PRESETS}
      compareActions={[
        <FilterActions.CompareToPreviousPeriod />,
        <FilterActions.Equalize />,
      ]}
    />
  );
};

const ConceptCreationPeriodFilter = (props) => {
  return (
    <Filter.DateRangePicker
      title={'Concept added'}
      placeholder={'Select period'}
      name={FILTER_CREATIVE_CONCEPT_CREATION_PERIOD}
      maxDate={new Date()}
      {...props}
      presets={CREATION_PERIOD_PRESETS}
      compareActions={[
        <FilterActions.CompareToPreviousPeriod />,
        <FilterActions.Equalize />,
      ]}
    />
  );
};

const TestedFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Tested'}
      name={FILTER_CREATIVE_TESTED}
      source={loadTested}
      compareActions={[<FilterActions.Equalize />]}
      {...props}
    />
  );
};

const AICreatedFilter = (props) => {
  return (
    <Filter.Select
      title={'AI Generated'}
      name={FILTER_IS_AI_CREATED}
      source={loadCreativeAiCreatedTypes}
      compareActions={[<FilterActions.Equalize />]}
      {...props}
    />
  );
};

export default {
  CreatedBy: isGoGameEnv ? CreatedByFilter : null,
  CreativeTypes: CreativeTypesFilter,
  Languages: LanguagesFilter,
  Lengths: LengthsFilter,
  MediaTypes: MediaTypesFilter,
  Orientations: OrientationsFilter,
  RequestedBy: isGoGameEnv ? RequestedByFilter : null,
  Resolutions: ResolutionsFilter,
  Sizes: SizesFilter,
  Authors: isGoGameEnv ? AuthorsFilter : null,
  ProductionTypes: isGoGameEnv ? ProductionTypesFilter : null,
  Enhancers: EnhancersFilter,
  OS: OSFilter,
  Colors: ColorsFilter,
  IncludedTags: IncludedTagsFilter,
  ExcludedTags: ExcludedTagsFilter,
  Statuses: isGoGameEnv ? StatusesFilter : null,
  CreationPeriod: CreationPeriodFilter,
  ConceptCreationPeriod: ConceptCreationPeriodFilter,
  EndCard: EndCardFilter,
  Tested: isGoGameEnv ? TestedFilter : null,
  AICreated: isGoGameEnv ? AICreatedFilter : null,
};
